<template>
  <span
    class="middle-ellipsis"
    :title="title"
    @mouseenter="updateTitle"
  ><span ref="head" class="middle-ellipsis__head">{{ parts.head }}</span><span class="middle-ellipsis__tail">{{ parts.tail }}</span></span>
</template>

<script setup>
// SP-14857 - Les noms de sous-comptes commencent souvent par celui du parent
// (« Edgar & Cooper - Lyon ») : une ellipse en fin masquait la seule partie utile.
// La fin reste toujours visible, seul le début se tronque.
// Aucun espace entre les spans du template : white-space: pre les afficherait.
import { computed, ref } from 'vue';

defineOptions({ name: 'MiddleEllipsis' });

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  // Nombre de caractères de fin toujours visibles (étendu jusqu'au début du mot).
  tailLength: {
    type: Number,
    default: 12,
  },
});

const MAX_TAIL_LENGTH = 20;

const head = ref(null);
const title = ref(null);

// Tooltip natif seulement quand le début est réellement tronqué, recalculé au survol.
const updateTitle = () => {
  title.value = head.value && head.value.scrollWidth > head.value.clientWidth ? props.text : null;
};

const parts = computed(() => {
  const text = props.text || '';
  if (text.length <= props.tailLength) {
    return { head: text, tail: '' };
  }

  let cut = text.length - props.tailLength;
  const wordStart = text.lastIndexOf(' ', cut);
  if (wordStart > 0 && text.length - wordStart <= MAX_TAIL_LENGTH) {
    cut = wordStart;
  }

  return { head: text.slice(0, cut), tail: text.slice(cut) };
});
</script>

<style scoped>
.middle-ellipsis {
  display: inline-flex;
  max-width: 100%;
  min-width: 0;
  vertical-align: bottom;
  white-space: pre;
}

.middle-ellipsis__head {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.middle-ellipsis__tail {
  flex: 0 0 auto;
}
</style>
